import {
    Box,
    Divider,
    Grid,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { Favorite as FavoriteIcon } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { WalletSelectOptionRendererProps } from './types';

const FredAddressBookContactOptionRendererComponent = React.forwardRef((props: WalletSelectOptionRendererProps, ref) => {
    const {
        innerProps,
        innerRef,
        getValue,
        data
    } = props;

    const theme = useTheme<typeof muiTheme>();
    const classes = muiStyles(props);

    const optionRef = React.useRef<any>(innerRef);
    const contact = data.value;
    const currentValue = getValue().length === 1 && getValue()[0].value.Account;
    const groupIndex = Number(innerProps.id.split('-')[4]);
    let selected = false;
    if (currentValue === contact.Account) {
        selected = true;
    }

    return (
        <Grid
            className={`${classes.root} ${selected ? classes.selected : classes.hover}`}
            container
            ref={optionRef}
            spacing={0}
            {...innerProps}
        >
            {
                !!groupIndex &&
                <Grid
                    container
                    item
                    justifyContent='center'
                    xs={12}
                >
                    <Divider className={classes.optionDivider} />
                </Grid>
            }
            <Grid
                item
                xs={12}
            >
                <Box
                    pl={2}
                    pr={2}
                >
                    {contact.FirmName}
                </Box>
            </Grid>
            <Grid
                container
                direction='row'
                wrap='nowrap'
            >
                <Box pl={2} />
                <Grid
                    alignItems='center'
                    container
                    item
                    justifyContent='center'
                    xs={1}
                >
                    {contact.IsFavorite && (
                        <FavoriteIcon
                            className={classes.favoriteIcon}
                            iconColor={theme?.app?.clientTheme.colors.highlightColor1 || '#EDDA26'}
                        />
                    )}
                </Grid>
                <Grid
                    container
                    direction='column'
                    item
                    spacing={0}
                    xs={11}
                >
                    {contact.NickName &&
                        <Typography variant='body1'>
                            {contact.NickName}
                        </Typography>}
                    <Typography variant='body1'>
                        {contact.AccountName ? contact.AccountName : '-'}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
});

FredAddressBookContactOptionRendererComponent.displayName = 'FredAddressBookContactOptionRendererComponent';
export default FredAddressBookContactOptionRendererComponent;